import { Languages } from 'utils/constants';

export const Locales = [Languages.english.locale, Languages.spanish.locale];
